export default {
  eyebrow: 'Portal partener',
  title: 'Taxe și valută',
  description:
    'Categorii de taxe implicite pe care restaurantele dvs. le moștenesc, dacă nu suprascriu o categorie individual.',
};
